import React from 'react';
import { useTranslation } from 'react-i18next';

interface PayrollStatusBadgeProps {
  status: 'paid' | 'partially_paid' | 'pending' | 'failed' | 'overdue' | 'coming';
  text?: string;
}

const PayrollStatusBadge: React.FC<PayrollStatusBadgeProps> = ({ status, text }) => {
  const { t } = useTranslation();

  const getBadgeColor = () => {
    switch (status) {
      case 'paid':
        return 'success';
      case 'partially_paid':
        return 'warning';
      case 'pending':
        return 'secondary';
      case 'overdue':
        return 'danger';
      case 'coming':
        return 'info';
      case 'failed':
        return 'danger';
      default:
        return 'secondary';
    }
  };

  const getDefaultText = () => {
    switch (status) {
      case 'paid':
        return t('payroll.statusPayroll.paid');
      case 'partially_paid':
        return t('payroll.statusPayroll.partially_paid');
      case 'pending':
        return t('payroll.statusPayroll.pending');
      case 'failed':
        return t('payroll.statusPayroll.failed');
      case 'overdue':
        return t('payroll.statusPayroll.overdue');
      case 'coming':
        return t('payroll.statusPayroll.coming');
      default:
        return t('unknown');
    }
  };

  return (
    <span className={`badge badge-soft-${getBadgeColor()} d-inline-flex align-items-center`}>
      <i className="ti ti-circle-filled fs-5 me-1"></i>
      {text || getDefaultText()}
    </span>
  );
};

export default PayrollStatusBadge;
